import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type Status = "approved" | "pending" | "blocked" | "expired" | "cancelled" | "completed" | "active" | "suspended" | "inactive" | "rejected";

const statusStyles: Record<Status, string> = {
  approved: "bg-success/10 text-success border-success/20",
  completed: "bg-success/10 text-success border-success/20",
  active: "bg-success/10 text-success border-success/20",
  pending: "bg-warning/10 text-warning border-warning/20",
  blocked: "bg-destructive/10 text-destructive border-destructive/20",
  expired: "bg-destructive/10 text-destructive border-destructive/20",
  rejected: "bg-destructive/10 text-destructive border-destructive/20",
  suspended: "bg-destructive/10 text-destructive border-destructive/20",
  cancelled: "bg-muted text-muted-foreground border-border",
  inactive: "bg-muted text-muted-foreground border-border",
};

export function StatusBadge({ status }: { status: Status }) {
  return (
    <Badge variant="outline" className={cn("capitalize whitespace-nowrap", statusStyles[status])}>
      {status}
    </Badge>
  );
}
